import React, { memo, useState ,useEffect} from 'react'
import { useSpring} from 'react-spring'

import { Container, Banner, BannerText, Thumbnail, Overlay, Image,CloseButton } from './PhotoGallery.styled.js'
import { useCanvas } from 'store/AppStore'



const Gallery = ({ images }) => {
  // State variables
  const [activeIndex, setActiveIndex] = useState(-1);
  const [overlayVisible, setOverlayVisible] = useState(false);
  const {isTouchMode,openImage,isOptionPanelOpen } = useCanvas();


  // Open the iimage from the AOS
useEffect( () =>{
  switch(openImage){
    case 'graph1':
      handleThumbnailClick(0)

      //if(isOptionPanelOpen) handleThumbnailClick(0)
      break;
      case 'graph2':
       handleThumbnailClick(1)

    
      break;
      case 'graph3':
        handleThumbnailClick(2)

    
      break;
      default:
        handleCloseClick()

      break;
  }
  //if (!isOptionPanelOpen) handleCloseClick()

},[openImage,isOptionPanelOpen])

  // Spring for overlay opacity
  const overlaySpring = useSpring({
    opacity: overlayVisible ? 1 : 0,
    pointerEvents: overlayVisible ? 'auto' : 'none',
  });


//transform: activeIndex >= 0 ? 'scale(1)' : 'scale(0.5)',
  // Spring for image scale and opacity
  const imageSpring = useSpring({
    
    opacity: activeIndex >= 0 ? 1 : 0,
  });

  // Click handler for thumbnails
  const handleThumbnailClick = (index) => {
    setActiveIndex(index);
    setOverlayVisible(true);
  };

  // Click handler for close button
  const handleCloseClick = () => {
    setActiveIndex(-1);
    setOverlayVisible(false);
  };

  return (
    <Container>
      <Banner hideAos={isTouchMode}>
        <div>
            {images.map((image, index) => (
              <Thumbnail
                key={index}
                src={image.thumb}
                alt={`Image ${index + 1}`}
                active={index === activeIndex}
                onClick={() => handleThumbnailClick(index)}
              />
            ))}
          </div>
          <div>
              {images.map((image, index) => (
                <BannerText key={index} active={index === activeIndex}><h3   >{image.title}</h3></BannerText>
              ))}
          </div>
      </Banner>
      <Overlay style={overlaySpring} onClick={handleCloseClick} />
      <Image
        style={imageSpring}
        src={activeIndex >= 0 ? images[activeIndex].full : ''}
        loop={false}
      />
      {activeIndex >= 0 && (
        <CloseButton onClick={handleCloseClick}>
          <span>&times;</span>
        </CloseButton>
      )}
    </Container>
  );
};


export default memo(Gallery)
